import React from 'react';
import PropTypes from 'prop-types';

import ProductPromoCardFs from './product/ProductPromoCardFs';
import ProductCardFs from './product/ProductCardFs';
import RecipeCardFs from './recipe/RecipeCardFs';
import RecipePromoCardFs from './recipe/RecipePromoCardFs';
import ContentCardFs from './content/ContentCardFs';
import RelatedCardFs from './related/RelatedCardFs';
import ArticleCardFs from './article/ArticleCardFs';
import PageCardFs from './page/PageCardFs';
import styled from 'styled-components';
const RandomDefaultStyle = styled.div``;
export default RandomDefaultStyle;

export const RenderCardType = ({ type, promo = false, className, props }) => {
  const types = {
    product: !promo ? <ProductCardFs classValue={className} {...props} /> : <ProductPromoCardFs classValue={className} {...props} />,
    recipe: !promo ? <RecipeCardFs classValue={className} {...props} /> : <RecipePromoCardFs classValue={className} {...props} />,
    content: <ContentCardFs {...props} />,
    page: <PageCardFs {...props} />,
    related: <RelatedCardFs {...props} />,
    article: <ArticleCardFs {...props} />,
  };

  if (type in types) return types[type];

  return types.content;
};

RenderCardType.propTypes = {
  type: PropTypes.oneOf(['product', 'page', 'recipe', 'content', 'related', 'article']),
  promo: PropTypes.bool,
};